// actions are commited
import {GET_CLIP_MOMENTS} from '../actions/types';

const initialState = {
    momentClips: []
};

export default function (state = initialState, action) {
    switch (action.type) {

        case GET_CLIP_MOMENTS : {
            return {
                ...state,
                momentClips: action.payload
            }
        }
        default :
            return state;
    }
}